import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InfoStep } from '../backend-process/backend-process-presentation/backend-process-presentation.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TimelineComponent } from '../timeline/timeline.component';
import { TimelineItemComponent } from '../timeline/timeline-item/timeline-item.component';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { NgTemplateOutlet } from '@angular/common';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-next-steps',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './next-steps.component.html',
  imports: [
    TranslateDirective,
    TimelineComponent,
    TimelineItemComponent,
    BasicCardComponent,
    NgTemplateOutlet,
    TranslatePipe,
    SafeHtmlPipe,
  ],
})
export class NextStepsComponent {
  asCard = input<boolean>(false);
  processTitle = input<string>('');
  infoSteps = input<InfoStep[]>([]);
  stepsTitle = input<string>('summary.whatNext');

  formattedSteps = computed(() => {
    return this.infoSteps().map(step => {
      return {
        ...step,
        label: Array.isArray(step.label) ? step.label : [step.label],
      };
    });
  });
}
